import { OrdersQueryVariables } from 'src/api/order_repository';
import {
  DEFAULT_CURRENT_PAGE,
  DEFAULT_PAGE_SIZE,
} from 'src/components/pagination/use_pagination';
import { getPlatform } from 'src/config/environment';
import {
  getStatusesFromFilter,
  parseSpecimenTypeFilterValues,
  parseStatusFilterValue,
} from 'src/distribution_platforms/features/order_list';
import { Seq, SortBy } from 'src/types';
import { DistributionPlatform } from 'src/types/env';
import { WorkflowType } from 'src/types/workflows';
import { isClinicAdmin, isOrderingPhysician } from 'src/utils';
import { getEnumValue } from 'src/utils/enum_utils';

/** Default sort for order list: LDT uses StatusUpdatedAt, SAMD uses SubmittedAt. */
export function getDefaultOrdersSortBy(): SortBy {
  return getPlatform() === DistributionPlatform.Ldt
    ? SortBy.StatusUpdatedAt
    : SortBy.SubmittedAt;
}

export function getOrdersQueryParams(
  searchParams: URLSearchParams,
  workflowType: WorkflowType,
): OrdersQueryVariables {
  // Extract status filter from search params, parse to enum value
  const statusFilter = parseStatusFilterValue(searchParams.get('statusFilter'));
  const statusFilterArray = getStatusesFromFilter(statusFilter, workflowType);

  const specimenTypeFilterArray = parseSpecimenTypeFilterValues(
    searchParams.get('specimenTypeFilter'),
  );
  const currentPage = parseInt(
    searchParams.get('page') || `${DEFAULT_CURRENT_PAGE}`,
  );

  const params: OrdersQueryVariables = {
    page: Math.max(
      DEFAULT_CURRENT_PAGE,
      isNaN(currentPage) ? DEFAULT_CURRENT_PAGE : currentPage,
    ),
    perPage: DEFAULT_PAGE_SIZE,
    sortBy: getEnumValue(
      SortBy,
      searchParams.get('sortBy') || '',
      getDefaultOrdersSortBy(),
    ),
    seq: getEnumValue(Seq, searchParams.get('seq') || '', Seq.Desc),
    searchText: searchParams.get('searchText') || '',
    statuses:
      statusFilterArray && statusFilterArray.length > 0
        ? statusFilterArray
        : null,
    specimenTypes: specimenTypeFilterArray,
  };

  if (getPlatform() === DistributionPlatform.Ldt) {
    const includeNeedsAttention =
      workflowType === WorkflowType.CLINIC &&
      (isOrderingPhysician() || isClinicAdmin());

    return {
      ...params,
      includeNeedsAttention,
      ...(workflowType === WorkflowType.CLINIC
        ? {
            needsAttentionFirst:
              searchParams.get('needsAttentionFirst') === 'true',
          }
        : {}),
    };
  } else {
    return params;
  }
}
